import { render, staticRenderFns } from "./OpenCartAddMain.vue?vue&type=template&id=64ad5593&scoped=true&"
import script from "./OpenCartAddMain.vue?vue&type=script&lang=js&"
export * from "./OpenCartAddMain.vue?vue&type=script&lang=js&"
import style0 from "./OpenCartAddMain.vue?vue&type=style&index=0&id=64ad5593&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ad5593",
  null
  
)

export default component.exports